import React from 'react';
import { useSelector } from 'react-redux';

import { ProductReviews } from 'src/components/organisms/ProductReviews/components/ProductReviews/ProductReviews';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProductReviews } from 'src/redux/selectors';
import { trackReviewsImpression } from '../tracking/reviewsEvents';

export const ProductReviewsContainer = () => {
  const reviews = useSelector((state: ReduxApplicationState) => selectProductReviews(state));
  const productCode = useSelector((state: ReduxApplicationState) => state.product.code);

  return (
    <ProductReviews
      onVisible={trackReviewsImpression}
      productCode={productCode}
      reviews={reviews}
    />
  );
};
